import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import {
    TRANSACTION_REVIEW_FIELD_LABELS,
    TransactionReviewField,
} from "@common/types/transactionFieldReview";
import { pluralize } from "@common/helpers/string";

interface ReviewFilterLabelProps {
    filters: Pick<FiltersTypes, "reviewedFields" | "unreviewedFields">;
    mode: "reviewed" | "unreviewed";
}

function fieldLabels(fields: TransactionReviewField[]): string {
    if (fields.length === 0) {
        return "";
    }
    if (fields.length === 1) {
        return TRANSACTION_REVIEW_FIELD_LABELS[fields[0]];
    }
    return `${fields.length} ${pluralize("field", fields.length)}`;
}

export const ReviewFilterLabel: React.FC<ReviewFilterLabelProps> = ({
    filters,
    mode,
}) => {
    if (mode === "reviewed") {
        const reviewedFields = (filters.reviewedFields ??
            []) as TransactionReviewField[];
        return <>Reviewed: {fieldLabels(reviewedFields)}</>;
    }

    const unreviewedFields = (filters.unreviewedFields ??
        []) as TransactionReviewField[];
    return <>Unreviewed: {fieldLabels(unreviewedFields)}</>;
};
